export const isChristmas = (): boolean => {
  // check if december
  return new Date().getMonth() === 11;
};

export const isServer = (): boolean => typeof window === "undefined";

export const API_ENDPOINT =
  process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337";
